module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "top"
  }, [_c('router-link', {
    staticClass: "left brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "left-img",
    attrs: {
      "src": _vm.logoImage
    }
  }), _c('h1', {
    staticClass: "left-h1"
  }, [_c('strong', [_c('span', {
    staticClass: "red nav"
  }, [_vm._v("NAV")])]), _vm._v("Legal "), _c('span', {
    staticClass: "red"
  }, [_vm._v("Notaries")])])]), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "right-p"
  }, [_vm._v("Call Us Today: "), _c('span', {
    staticClass: "red phone"
  }, [_vm._v(_vm._s(_vm.$store.state.phone))])])])], 1), _c('nav', {
    staticClass: "bottom"
  }, [_c('router-link', {
    staticClass: "bottom-a",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _c('span', {
    on: {
      "mouseenter": function($event) {
        _vm.dropdown = true
      },
      "mouseleave": function($event) {
        _vm.dropdown = false
      },
      "click": function($event) {
        _vm.dropdown = false
      }
    }
  }, [_c('router-link', {
    staticClass: "bottom-a",
    attrs: {
      "to": {
        name: 'NotariesAll'
      }
    }
  }, [_vm._v("Find A Notary")]), (_vm.dropdown) ? _c('ul', {
    staticClass: "dropdown"
  }, _vm._l((_vm.$store.state.provinces), function(province) {
    return _c('li', {
      staticClass: "dropdown-li",
      on: {
        "click": function($event) {
          _vm.goTo(province.province.toLowerCase())
        }
      }
    }, [_c('a', {
      staticClass: "dropdown-li-a",
      attrs: {
        "href": _vm.to(province.province.toLowerCase())
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._v(_vm._s(province.province))])])
  })) : _vm._e()], 1), _c('router-link', {
    staticClass: "bottom-a",
    attrs: {
      "to": "/services"
    }
  }, [_vm._v("Services")]), _c('router-link', {
    staticClass: "bottom-a",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _c('router-link', {
    staticClass: "bottom-a",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f672dae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 161
// module chunks = 9